// Global Instructions Rule Applied!
import type { ViewConfigColumn } from '../../../core/components/ViewConfig/types.ts'

/** Reporting/API metadata may omit `tag_display` for these keys; set explicitly for tag-style columns. */
const TAG_DISPLAY_VALUE_KEYS = new Set(['role', 'prog__investment_stats'])

export function augmentCompaniesViewConfigColumns(columns: ViewConfigColumn[]): ViewConfigColumn[] {
  return columns.map((c) =>
    TAG_DISPLAY_VALUE_KEYS.has(c.valueKey) ? { ...c, tagDisplay: true } : c
  )
}
